<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="600"
    v-if="isDataLoaded"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
        <form class="row ma-0 py-0">
          <div class="col-12 py-0 my-0">
            <v-autocomplete
              v-model="formData.country_code"
              :label="$t('country_code')"
              :items="serverData.countries"
              item-text="text"
              item-value="index"
              dense
              outlined
              clearable
              :error-messages="country_codeErrors"
              @blur="$v.formData.country_code.$touch()"
            />
          </div>
        </form>

        <!--begin::Actions-->
        <div class="mb-4 mt-2 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            {{ submitButtonText }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "ActionsDialog",
  props: ["refresher"],
  mixins: [validationMixin],
  validations() {
    return {
      formData: {
        country_code: { required },
      },
    };
  },
  data: () => ({
    dialog: false,
    serverData: null,

    formData: {
      id: null,
      country_code: null,
    },
  }),
  methods: {
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    resetFormData() {
      // this.serverData = null;

      this.formData = {
        id: null,
        country_code: null,
      };
    },
    loadDataFromServer() {
      // this.$store.dispatch(GET_DATA);
      this.$store.commit(SET_PAGE_LOADING, true);
      if (this.actionType) {
        let sendData = {
          id: this.$store.getters.getItemForAction.id,
        };
        ApiService.post("/shipping/dhl_wy_disable_countries/edit", sendData)
          .then(async ({ data }) => {
            // console.log(data);

            setTimeout(async () => {
              this.formData = {
                ...data.dhl_wy_disable_country,
              };

              this.serverData = data;
            }, 300);
            this.$store.commit(SET_PAGE_LOADING, false);
          })
          .catch(() => {
            this.dialog = false;
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      } else {
        ApiService.post("/shipping/dhl_wy_disable_countries/create")
          .then(({ data }) => {
            // console.log([...data.areas]);
            if (data.success) {
              this.serverData = data;

              this.$store.commit(SET_PAGE_LOADING, false);
            }
          })
          .catch(() => {
            this.dialog = false;
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      }
    },
    handleFormValidation(fieldName) {
      const errors = [];
      // if (!this.$v.formData[fieldName].$dirty) return errors;
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("numeric" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);

      let sendData = { country_code: this.formData.country_code };

      if (this.actionType) {
        sendData.id = this.$store.getters.getItemForAction.id;
      }
      // console.log("sendData", sendData);
      let actionUrl = "store";
      if (this.actionType) actionUrl = "update";
      ApiService.post(
        `/shipping/dhl_wy_disable_countries/${actionUrl}`,
        sendData
      )
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  computed: {
    // if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    country_codeErrors: function () {
      return this.handleFormValidation("country_code");
    },
    isDataLoaded() {
      return !!this.serverData;
    },
  },
};
</script>
